module.exports = __webpack_public_path__ + "img/public_resources_arrow_next.e5be1024.svg";